import { CommissionScheduleService } from './CommissionScheduleService.js';
import { RevenueScheduleService } from './RevenueScheduleService.js';
import { ClientService } from './ClientService.js';

export class CommissionService {
    static async getAll() {
        return CommissionScheduleService.getEnrichedAll();
    }

    static async getByOwner(userId) {
        return CommissionScheduleService.getByRep(userId);
    }

    static async createForDeal(deal) {
        if (!deal?.id || deal.commissionEligible === false) return [];

        let schedules = [];
        try {
            schedules = await RevenueScheduleService.getByDeal(deal.id);
        } catch (err) {
            console.warn('Failed to load existing schedules for commission create', err);
        }

        if (!schedules.length) {
            const client = await ClientService.getById(deal.clientId);
            schedules = await RevenueScheduleService.generateForDeal(deal, client?.name);
        }

        return CommissionScheduleService.generateForDeal(deal, schedules);
    }

    static async updateStatus(id, status, paidDate = null) {
        return CommissionScheduleService.updateStatus(id, status, { paidDate });
    }

    static ytdTotal(commissions, userId, year = new Date().getFullYear()) {
        return CommissionScheduleService.paidInYear(commissions, userId, year);
    }

    static async getLegacyCommissions() {
        return CommissionScheduleService.getAll();
    }
}
